<template>
  <div class="weekDays-selector">
    <span v-for="day in days">
      <input @change="handleChange($event ,day)"
             v-model="selected"
             type="checkbox"
             :id="day.day"
             :value="day.pos"
             class="weekday"/>
      <label :for="day.day">{{ day.day.charAt(0) }}</label>
    </span>
  </div>
</template>
<script>
  import days from './../mixins/days'

  export default {
    name: "day-selector",
    mixins: [days],
    props: ['model'],
    model: {
      prop: 'model',
      event: 'update-model'
    },
    data: () => ({
      selected: []
    }),
    methods: {
      handleChange(e, day) {
        this.$emit('change', e, day);
        this.$emit('update-model', this.selected)
      }
    }
  }
</script>
<style scoped lang="scss">
  .weekDays-selector input {
    display: none !important;
  }

  .weekDays-selector input[type=checkbox] + label {
    display: inline-block;
    border-radius: 50%;
    background: #dddddd;
    height: 48px;
    width: 48px;
    margin-right: 3px;
    line-height: 46px;
    text-align: center;
    cursor: pointer;
    font-size: 1rem;
    transition: .2s ease-in-out;
  }

  .weekDays-selector input[type=checkbox]:checked + label {
    background: #092F6D;
    color: #ffffff;
  }

  .input-select-group {
    display: flex;

    .v-select:first-child {

      .vs__dropdown-toggle {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }

    }

    .v-select:last-child {
      .vs__dropdown-toggle {
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        margin-left: -1px;
      }
    }

    .v-select {
      flex-grow: 1;
    }
  }

  .flex-grow-1 {
    flex-grow: 1;
  }

  .btn-circle {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    padding: 0;
  }
</style>
